import React from 'react';
import { FormFieldsData, useShowContext } from 'ui-builder';

import styles from './IsRoadmapField.module.scss';

export interface IsRoadmapFieldProps {
  source: string
}

export default function IsRoadmapField(props: IsRoadmapFieldProps) {
  const context = useShowContext<FormFieldsData>();

  if (context?.data) {
    const value = context.data[props.source] as boolean;

    if (value) {
      return (
        <i className={styles.icon} title="Roadmap Task">
          &nbsp;
        </i>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
}
